import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {UserService} from '@core/services/user.service';
import {catchError, map} from 'rxjs/operators';
import {AuthService} from '@core/services/auth.service';
import {IUser} from '@core/models/user';

@Injectable({
    providedIn: 'root'
})
export class PageGuard implements CanActivate {
    constructor(private userService: UserService,
                private auth: AuthService,
                private router: Router) {

    }

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        const pathname = window.location.pathname;
        const params = JSON.stringify(route.queryParams);
        console.log(route.queryParams);
        return this.userService.getUser$
            .pipe(
                catchError(err => {
                    this.auth.clearUser();
                    if (params || !pathname.includes('auth/login')) {
                        localStorage.setItem('params', params);
                        localStorage.setItem('pathname', pathname);
                    } else {
                        localStorage.removeItem('pathname');
                        localStorage.removeItem('params');
                    }
                    this.router.navigate(['/auth']);
                    throw err;
                }),
                map((user: IUser) => {
                    if (user) {
                        return true;
                    } else {
                        // localStorage.setItem()
                        this.auth.logout();
                        this.router.navigate(['/auth']);
                        return false;
                    }
                })
            );

    }

}
